
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__user",
  "use": "icon__user-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"icon__user\"><g fill=\"#030F23\" fill-rule=\"evenodd\"><circle fill=\"#EAEDF1\" cx=\"32\" cy=\"32\" r=\"32\" /><path d=\"M32 20c-3.525 0-6.4 2.777-6.4 6.182 0 3.405 2.875 6.182 6.4 6.182 3.525 0 6.4-2.777 6.4-6.182C38.4 22.777 35.525 20 32 20Zm0 12.364c-5.875 0-10.667 4.628-10.667 10.303h2.134c0-4.564 3.808-8.243 8.533-8.243s8.533 3.679 8.533 8.243h2.134c0-5.675-4.792-10.303-10.667-10.303Zm0-10.303c2.367 0 4.267 1.835 4.267 4.12 0 2.287-1.9 4.122-4.267 4.122-2.367 0-4.267-1.835-4.267-4.121 0-2.286 1.9-4.121 4.267-4.121Z\" fill-opacity=\".25\" fill-rule=\"nonzero\" /></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconUserIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__user" {...restProps} />
    })
  